(function () {
    'use strict';

    angular
        .module('app')
        .directive('working', working);


    function working($compile) {
        // Usage:
        //     <button working='expression'></button>
        //     <input working='expression' />
        // Creates:
        //      Disables element and shows a spinner while working expression is true.
        // 
        var directive = {
            compile: compile,
            restrict: 'A',
            priority: 1000,
            terminal: true
        };
        return directive;

        function compile(element, attrs) {
            var spinner = angular.element(`<span ng-if="${attrs.working}"><i class="glyphicon glyphicon-refresh glyph-spin" style="margin-left:5px;"></i></span>`),
                nodeName = element[0].nodeName;

            element.removeAttr('working'); // prevent re-processing this directive

            if (nodeName === 'BUTTON') {
                // disable button while working
                var disabled = attrs.ngDisabled || '';
                if (disabled) {
                    disabled = '(' + disabled + ') || ';
                }
                disabled += attrs.working;
                attrs.$set('ngDisabled', disabled);

                element.append(spinner);    // spinner goes within the button element

            } else if (nodeName === 'INPUT') {
                // make input readonly while working
                var readonly = attrs.ngReadonly || '';
                if (readonly) {
                    readonly = '(' + readonly + ') || ';
                }
                readonly += attrs.working;
                attrs.$set('ngReadonly', readonly);

                // search for parent with 'form-group' class, and make sure it has 'has-feedback' class
                var formGroup = element.closest('.form-group');
                if (formGroup.length) {
                    if (!formGroup.hasClass('has-feedback'))
                        formGroup.addClass('has-feedback');

                    spinner.addClass('form-control-feedback');
                }

                element.after(spinner);     // spinner goes after the input element
            }

            return {
                //pre: function preLink(scope, iElement, iAttrs, controller) { },
                post: function postLink(scope, element, attrs, controller) {
                    $compile(element)(scope);
                }
            };
        }
    }

})();